module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerintro01",
      "epub:type": "introduction",
      "id": "intro",
      "role": "doc-introduction"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerintro01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "p1",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicrosthwaite0005#toc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Three Centuries of Financial Advice")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p1"
    }
  }), _vm._v("In January 2021 the apes arrived. Users of WallStreetBets, a community of millions of retail investors on the discussion website Reddit, began buying en masse into GameStop, a struggling video game retailer whose stock had been the subject of aggressive short selling. The concerted buying spree, using online commission-free trading platforms such as Robinhood, saw GameStop shares leap sensationally by more than 2,000 percent over the course of a fortnight, from just over $20 to $483."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en1",
      "id": "en1r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" The “short squeeze” caught the hedge funds off guard, with some reportedly closing their positions at the loss of billions of dollars."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en2",
      "id": "en2r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" The episode turned a spotlight on the growing influence of social media on the stock market. Indeed, the watchword of the Reddit users—“Apes Together Strong”—both mocks Wall Street’s dismissive attitude to supposedly ignorant outsiders and celebrates the (supposed) power of the internet to redress historic power imbalances in the market."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en3",
      "id": "en3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" Other “meme stocks” quickly followed GameStop, including AMC Entertainment, to the mystification of market professionals, who bemoaned the “flight to crap” and anxiously asked, “Are the Apes Now Running Wall Street?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en4",
      "id": "en4r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', [_vm._v("Though the apes were a new—and for many, unwelcome—player in the stock market menagerie of bulls, bears, stags, and lame ducks, there were historical parallels."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en5",
      "id": "en5r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" The most obvious one was hammered home incessantly by media commentators who insisted that meme mania was simply the latest in a long history of speculative bubbles, with the Dutch tulip mania of the 1630s and the South Sea Bubble of 1720 serving as favorite reference points."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en6",
      "id": "en6r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" Less commented on, however, was the way in which, though seemingly very modern, the GameStop saga provides an excellent vantage point from which to examine the long and poorly understood history of investment advice. The proliferation of tips and information in "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "2",
      "epub:type": "pagebreak",
      "id": "p2",
      "role": "doc-pagebreak"
    }
  }), _vm._v("cyberspace is just the latest stage in a process going back three centuries, for the much earlier technology of print acted in a very similar way, explaining and popularizing investment for large constituencies of readers in the eighteenth and nineteenth centuries. The appeal of printed investment advice was always explicitly democratic, holding out the promise of access to privileged knowledge that would level the playing field and shrink the gap between outsiders and insiders. When hip-hop star Megan Thee Stallion announces in her 2021 YouTube tutorial “Investing for Hotties” that “Buying stocks isn’t only for the big players. Anyone can start with as little as one dollar,” she is repeating almost verbatim the assurances made by generations of market democratizers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en7",
      "id": "en7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', [_vm._v("Niall Ferguson sees in the anti–Wall Street rhetoric of the apes, typified by the rallying cry of “fuck the hedgies,” the financial analogue of Donald Trump’s insurgent populism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en8",
      "id": "en8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" Yet this aggressive celebration of the “little man” battling powerful vested interests is nothing new, finding precursors in the populist advertising of disruptive nineteenth-century brokerages which exhorted their clients to follow their stock tips and “S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("QUEEZE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EARS")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en9",
      "id": "en9r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" More generally, angry skepticism about the morality of “City” insiders and their “shills” in the media is prefigured in much eighteenth- and nineteenth-century writing about the stock market, laden as it is with lurid warnings about the tricks and dodges of the financial elites. Likewise, the machismo of many of the “Generation Z” traders (“Let’s get fucking nuts . . . let’s strangle these people out”) reflects centuries-long habits of coding speculation as a masculine activity and the role of speculators as mastering a feminized market."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en10",
      "id": "en10r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" Though the history of printed advice has made genuinely useful information about the market more widely available, much of it has offered unrealistic visions of vast wealth easily won, and such visions are certainly widespread on social media today. Sports blogger turned day trader Dave Portnoy helpfully condensed his wisdom down to just two easy-to-follow rules: “1. Stocks only go up. 2. When in doubt whether to buy or sell see Rule #1.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en11",
      "id": "en11r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', [_vm._v("Portnoy’s rise to celebrity status, with 2.6 million Twitter followers by July 2021 and regular appearances on CNBC, is nothing unusual in the history of investment advice, where telling people how to make money by investing in the stock market has usually proven a surer route to wealth than actually investing in the stock market. Once established, the reputations of individual financial gurus can survive adverse outcomes: indeed, anyone stung by following Portnoy’s gung-ho approach and buying at the peak could not claim they were not warned, his Twitter bio pointing out, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "3",
      "epub:type": "pagebreak",
      "id": "p3",
      "role": "doc-pagebreak"
    }
  }), _vm._v("“I’m not a financial advisor. Don’t trust anything I say about stocks.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en12",
      "id": "en12r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" No matter how badly meme mania ends, it is unlikely to discredit the genre of investment advice, which over the centuries has shown a remarkable ability to survive crashes. The solution to bad advice has tended to be more advice, with countless competing providers promising to help retrieve investors’ fortunes. In the wake of GameStop, the website of British bank Halifax warned its customers to “Stop Taking Investment Advice from Social Media,” presenting instead a checklist “to help you avoid getting burnt.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en13",
      "id": "en13r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" Around the same time, research from F&C Investment Trust showed that recent events had encouraged 33 percent of Generation Z investors to start seeking out more information about investing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en14",
      "id": "en14r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', [_vm._v("Explaining how investment advice has come to occupy such a central role in today’s society is the central aim of this book. As such, it responds to a long-identified need. A decade ago, the historian of credit Lendol Calder observed that “the print culture that helped people make sense of money—through financial advice offered in books, newspapers, magazines, and advertisements—awaits its historian.” The need for a study of this print culture is all the more imperative since, as he claims, “concerns about money—how to get it, how to save it, how to invest, multiply, and spend it—have likely sold more books in the last two hundred years than any other subject after religion.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en15",
      "id": "en15r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" Likewise, James Vernon has identified investment manuals as a historical “treasure trove” which remains “untouched by historians.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en16",
      "id": "en16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" By paying far more attention to the canonical texts of political economy by authors like Adam Smith, John Stuart Mill, and John Maynard Keynes, historians have given us a partial and exclusive understanding of the development of economic knowledge. Certainly, the role of popularizers like Harriet Martineau, Jane Marcet, and Millicent Fawcett, influential “knowledge brokers” whose primers on political economy brought the ideas of these canonical writers to much larger readerships, is better appreciated than it used to be."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en17",
      "id": "en17r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" But a parallel literature, representing a grassroots economic wisdom written for those who were less interested in theories of how the economy worked than the practical issue of what to do with their money, has been largely neglected. This is particularly the case with investment guides to the stock market itself. By placing such advice literature center stage, this book offers an alternative economic history of the modern world.")]), _vm._v(" "), _c('p', [_vm._v("Rather than beginning with Smith’s "), _c('i', [_vm._v("Wealth of Nations")]), _vm._v(" (1776), our unconventional history commences with the texts that influenced Thomas Mortimer’s pioneering guide to the stock market, "), _c('i', [_vm._v("Every Man His Own")]), _vm._v(" "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "4",
      "epub:type": "pagebreak",
      "id": "p4",
      "role": "doc-pagebreak"
    }
  }), _c('i', [_vm._v("Broker")]), _vm._v(" (1761). Instead of progressing through Mill’s "), _c('i', [_vm._v("Principles of Political Economy")]), _vm._v(" (1848) to Keynes’s "), _c('i', [_vm._v("General Theory of Employment, Interest, and Money")]), _vm._v(" (1936), it plots a very different course, taking in texts like Thomas Fortune’s "), _c('i', [_vm._v("Epitome of the Stocks and Public Funds")]), _vm._v(" (1796), T. S. Harvey’s "), _c('i', [_vm._v("What Shall I Do with My Money?")]), _vm._v(" (1849), Emma Galton’s "), _c('i', [_vm._v("A Guide to the Unprotected in Every-day Matters Relating to Property and Income")]), _vm._v(" (1863), Moses Smith’s "), _c('i', [_vm._v("Plain Truths about Stock Speculation")]), _vm._v(" (1887), Richard D. Wyckoff’s "), _c('i', [_vm._v("Studies in Tape Reading")]), _vm._v(" (1910), Benjamin Graham and David Dodd’s "), _c('i', [_vm._v("Security Analysis: Principles and Technique")]), _vm._v(" (1934), Ralph Nelson Elliott’s "), _c('i', [_vm._v("Wave Principle")]), _vm._v(" (1938), Sylvia Porter and J. K. Lasser’s "), _c('i', [_vm._v("Managing Your Money")]), _vm._v(" (1953), Louis Rukeyser’s "), _c('i', [_vm._v("How to Make Money in Wall Street")]), _vm._v(" (1974), and Suze Orman’s "), _c('i', [_vm._v("9 Steps to Financial Freedom")]), _vm._v(" (1997). Our study encompasses both well-known works and ones that have been long forgotten—around three hundred in total—to present the most comprehensive study of the development of financial advice writing to date."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en18",
      "id": "en18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', [_vm._v("Though many of our authors, beginning with Mortimer himself, also gave financial advice in personal or professional capacities, our main interest is in print advice and its online equivalents today. Of course, print features prominently in many historical accounts of the development of the market and its extension beyond face-to-face relations. Printed “price courants” were a key constituent of early financial markets, facilitating the transmission of market data across space and time, while newspapers were crucial in communicating a wider range of financial information to market participants."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en19",
      "id": "en19r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])]), _vm._v(" The nineteenth-century proliferation of forms of writing on finance has attracted much attention, as has the relationship between styles and genres."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en20",
      "id": "en20r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])]), _vm._v(" Historians have shown how print could sustain financial fraud, cheaper printing and postal technologies permitting deception by mail order on a grand scale."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en21",
      "id": "en21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" Likewise, the earliest economic forecasters used print and post to reach large followings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en22",
      "id": "en22r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" Yet none of these works explore the origins, development, and implications of stock market investment advice in print over three centuries.")]), _vm._v(" "), _c('p', [_vm._v("Print allowed the mass production of advice, and it is this phenomenon of advice transcending face-to-face relations and reaching first hundreds, then thousands—and eventually millions—of investors that we examine. Relatively cheap print democratized access to advice—investors did not need the cultural capital required to speak to a solicitor, banker, or stockbroker, simply the few shillings or cents to buy a pamphlet. Moreover, investment circulars were increasingly offered for free as the market expanded in the later nineteenth century. This had obvious implications for "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "5",
      "epub:type": "pagebreak",
      "id": "p5",
      "role": "doc-pagebreak"
    }
  }), _vm._v("class but also for gender: print offered women opportunities for financial engagement even when social stigmas militated against this, and even when, as we shall see, such texts did not address them directly. Thus, the history of printed investment advice makes it possible to trace how authors and their publishers encouraged wider constituencies of investors to identify with the stock market, rather than restricting our focus to the activities of social and financial elites. Indeed, although we are interested in the forms of knowledge, institutions, and practices that constitute stock market investment advice in the broadest sense, the book focuses on advice written for ordinary citizens, rather than experts and professionals. Moreover, it is chiefly interested in the specific genre of the stock market investment advice manual and related varieties of investment advice in the financial press.")]), _vm._v(" "), _c('p', [_vm._v("The term “investment manual” suggests a uniformity that would be misleading. This advice took many forms: from hefty and expensive catalogs of stocks and shares to single-page tip sheets, from treatises puffing a new technology to glossaries of stock market terminology, from hagiographies of successful market operators to descriptions of systems and methods for investment, and from airport best sellers to online blogs. Often a single text will contain several such elements. Indeed, the generic diversification of financial advice, which has become particularly apparent since the advent of the internet, is actually a feature of our story throughout its three-hundred-odd years. Mortimer’s pioneering text did not emerge in a vacuum; rather, it drew on wider traditions of writing about money, and we therefore show how stock market advice texts at various points borrow from and relate to wider bodies of knowledge, whether broader currents of self-improvement writing, advice on other financial topics, fictional representations of the market, or academic economic writing.")]), _vm._v(" "), _c('p', [_vm._v("Though some market manuals sought to provide basic instruction on how to invest rather than guaranteeing success (“how-to” guides rather than “how-to-win” guides), the appeal of the genre increasingly came to rest on the fantasy of easy profits and the certainty of success it promised, either explicitly or implicitly."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en23",
      "id": "en23r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" Our earlier chapters document the growing confidence and inflation of claims made by the genre while our later chapters explore how the genre survived—and thrived—despite the mounting body of evidence in the twentieth century that consistently “beating the market” was an impossibility. If it was true, as Burton Malkiel claimed, that “a blindfolded monkey throwing darts at a newspaper’s financial pages” could select as good a portfolio as a professional financial analyst, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "6",
      "epub:type": "pagebreak",
      "id": "p6",
      "role": "doc-pagebreak"
    }
  }), _vm._v("then why bother purchasing a guide to the stock market?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en24",
      "id": "en24r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])]), _vm._v(" The resilience of the stock market advice genre in spite of its very obvious limitations is a puzzle that this book hopes to explain.")]), _vm._v(" "), _c('p', [_vm._v("Ours is an Anglo-American rather than a global history. This is not to deny the existence and importance of financial advice literature in other parts of the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en25",
      "id": "en25r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" But there is a logic to confining ourselves to Britain and the United States. Our story begins in London with the set of innovations commonly known as the Financial Revolution, which drew on Dutch, French, and Scottish practices, in the late seventeenth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en26",
      "id": "en26r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])]), _vm._v(" The power of empire helped London to become the world’s preeminent financial center by the early nineteenth century, a century which saw the London Stock Exchange flourish as the largest and most sophisticated in the world. By the late nineteenth century, US markets had grown significantly in influence and, after World War I, London was clearly in the shadow of New York. Our coverage consequently shifts to focus increasingly on the US market in the later chapters of the book, which is designed to incorporate the two largest financial markets of the modern age in the period when each was in the ascendant. Throughout, we place investment advice in the context of the actual development of the stock market, and we explore the changing relationship between the stock market, the wider economy, and related forms of wealth creation and management.")]), _vm._v(" "), _c('p', [_vm._v("The book makes five key arguments about stock market investment advice. First, this advice literature is not a natural and inevitable result of the growth of the stock market. Rather, it is the creation of opportunistic and entrepreneurial writers and publishers who see an opportunity to make money not through the stock market itself but by creating a market for information and advice on it. Second, this investment advice does not simply reflect the market unproblematically: it actively constructs this market by embedding assumptions about it, thus creating a way of seeing the market that begins to seem simple common sense. Third, financial advice is not simply financial. It increasingly represents a form of self-fashioning, borrowing from self-help literature to reach far beyond the pecuniary and into the personal. More than just wealth, it offers its readers the promise of self-mastery and self-fulfillment. Fourth, by the twentieth century, advice literature begins to reshape the wider landscape of personal financial advice more generally, reframing investment not as a possibility but as a responsibility. Financial strategies, metaphorically and literally, come to revolve around the stock market. Fifth, as we approach the present, investment advice comes to reshape the whole self-help paradigm "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "7",
      "epub:type": "pagebreak",
      "id": "p7",
      "role": "doc-pagebreak"
    }
  }), _vm._v("itself, in its thoroughgoing financialization of the self. Investment advice’s journey from subgenre to master category is the story that this book maps.")]), _vm._v(" "), _c('p', [_vm._v("An interdisciplinary approach, bringing together financial history and literary studies, is critical to unlocking the significance of this large corpus of investment texts. This book is therefore both a substantial work of historical excavation, rediscovering a neglected but substantial body of writing, and also offers a methodologically innovative reading of these texts that models a new approach to studying writing about the financial market."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicrosthwaite0015#en27",
      "id": "en27r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])]), _vm._v(" Stock market advice is not solely concerned with the technicalities of stock picking: it also does important cultural work. This book uncovers the desires that this advice taps into, the narratives and metaphors it mobilizes, and the assumptions it makes. Once invested in the stock market, readers became invested in a much bigger ideological project. Stock market advice came to shape a new kind of ideal citizen, for whom risk was individualized, the future turned into a revenue stream, and the self into an entrepreneurial project. Exposing this demonstrates how supposedly immutable economic laws are not timeless and natural but are constructed through social practices and cultural discourses. In short, the book explains how and why the genre of financial advice helped persuade Britons and Americans to think of their homes, their futures, and themselves as speculative investments.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ce38f09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-crosthwaite-0006.vue
// module id = 69
// module chunks = 0